import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    reportTypeId: Yup.number(),
    email: Yup.string().email("Please enter a valid email").required("Please enter Email")
});